import React from 'react';
import { Modal } from 'antd';
import { useReadOnly } from '@spark';

import {
    ExclamationCircleOutlined
} from '@ant-design/icons';

import { colors } from '@/shared/tokens/colors';

const title = <div
    style={{ marginLeft: '12px', fontSize: '20px', fontWeight: 'bold' }}
>
    Remove From A/B Testing <ExclamationCircleOutlined style={{ marginLeft: '5px', color: colors.red }} />
</div>

export default function RemoveABTestingModal(props) {
    const { readOnly } = useReadOnly();

    const handleOk = () => {
        props.handleOk(false);
    };

    return (
        <div>
            <Modal
                open={props.isOpen}
                onOk={handleOk}
                okButtonProps={{ disabled: readOnly }}
                onCancel={props.handleCancel}
                title={title}
                className='train-modal'
                centered
            >
                <div style={{ marginLeft: '15px' }}>
                    Are you Sure You want to remove Item from A/B Testing?
                </div>
            </Modal>
        </div>
    );
};

